(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1762],{

/***/ 89346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95627);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18132);
/* harmony import */ var src_components_NltOffers___WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42702);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26718);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71033);
/* harmony import */ var src_utils_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13925);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);











const NltContentInfo = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => __webpack_require__.e(/* import() */ 1572).then(__webpack_require__.bind(__webpack_require__, 1572)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(1572)]
  }
});
const MobileActionBar = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => Promise.all(/* import() */[__webpack_require__.e(3344), __webpack_require__.e(3292), __webpack_require__.e(9653), __webpack_require__.e(9518)]).then(__webpack_require__.bind(__webpack_require__, 57347)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(57347)]
  }
});
const NltOffersContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => __webpack_require__.e(/* import() */ 4330).then(__webpack_require__.bind(__webpack_require__, 14330)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(14330)]
  }
});
const PageHeaderContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(() => __webpack_require__.e(/* import() */ 9729).then(__webpack_require__.bind(__webpack_require__, 1759)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(1759)]
  }
});

const NltSearchPage = _ref => {
  let {
    page
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)();
  const visibleOnMobile = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useBreakpointValue */ .Sx)({
    base: true,
    md: false
  });
  const requestedPage = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(state => state.nlt.listingPage);
  (0,src_utils_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useBackButton */ .Kx)();
  const crumbs = [{
    page: 'Home Page',
    href: '/',
    title: 'Home Page'
  }, {
    page: 'Offerte Noleggio a Lungo Termine',
    href: '/noleggio-a-lungo-termine',
    title: 'Offerte Noleggio a Lungo Termine'
  }];
  const metaPage = Math.max(page || 0, requestedPage || 0, 1);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
    bgColor: "baseNeutral.100",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_0___default()), {
      id: "2825298273",
      children: ["@media (max-width:600px){#CookiebotWidget{bottom:66px !important;z-index:calc(var(--cp-zIndices-modal) - 1) !important;}}"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      title: t('nltPage:header.title', {
        page: metaPage && metaPage > 1 ? ` pag. ${metaPage}` : ''
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      meta: metaPage && metaPage > 1 ? t(`nltPage:metaNextPages`, {
        returnObjects: true,
        page: metaPage
      }) : t(`nltPage:meta`, {
        returnObjects: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_10__/* .LinkRel */ .M, {
      rel: "canonical",
      href: `https://www.carplanner.com/noleggio-a-lungo-termine${page && page > 1 ? `?pagina=${page}` : ''}`
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(PageHeaderContainer, {
      title: t('nltPage:header.title'),
      description: t('nltPage:header.description'),
      crumbs: crumbs,
      linkHref: "/come-funziona-noleggio-a-lungo-termine",
      linkTitle: t('nltPage:header.howItWorksLink'),
      domain: "rent"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
      w: "100%",
      display: "inline-block",
      pb: "24px",
      pl: "1.5rem",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_NltOffers___WEBPACK_IMPORTED_MODULE_11__["default"], {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(NltOffersContainer, {})]
    }), requestedPage < 2 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(NltContentInfo, {
      title: t('nltPage:infoSection.title'),
      description: t('nltPage:infoSection.text'),
      asHtml: true
    }), visibleOnMobile && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MobileActionBar, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (NltSearchPage);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 13925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ useBackButton; },
/* harmony export */   "WQ": function() { return /* binding */ useCustomizedNltOffer; },
/* harmony export */   "gU": function() { return /* binding */ useSelectableDeposits; },
/* harmony export */   "rS": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* unused harmony export useQuerystringToFilterOffers */
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70461);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26869);
/* harmony import */ var src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37398);
/* harmony import */ var src_utils_querystring__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89363);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









const useQuerystringToFilterOffers = domain => {
  const dispatch = useDispatch();
  const performSearchOffers = domain === 'nlt' ? nltPerformSearchOffers : sellPerformSearchOffers;
  useEffect(() => {
    if (getSearchParams().size > 0) {
      dispatch(performSearchOffers());
    }
  }, []);
};
const useBackButton = () => {
  const onPopState = () => {
    if ((0,src_utils_querystring__WEBPACK_IMPORTED_MODULE_4__/* .getSearchParams */ .Qw)().size > 0) {
      location.reload();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  });
};
const useTracking = () => {
  const {
    query
  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  const {
    0: validQuery,
    1: setValidQuery
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
  const [allCookies, setCookie, removeCookie] = (0,react_cookie__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(['CP_TRACKER']);
  const path = '/';
  const today = new Date();
  const validity = parseInt("15");
  const expires = new Date(today.setDate(today.getDate() + validity));
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setValidQuery(query);
  }, [query]);

  const trackingData = () => allCookies['CP_TRACKER'];

  const setTracking = () => {
    const {
      utm_source: source = null,
      utm_medium: medium = null,
      utm_ref: referrer = null,
      utm_campaign: campaign = null,
      utm_campaign_date: campaign_date = null
    } = _objectSpread(_objectSpread({}, query), validQuery);

    if ((source || medium || referrer) && (typeof allCookies['CP_TRACKER'] === 'undefined' || !allCookies['CP_TRACKER'])) {
      setCookie('CP_TRACKER', {
        source,
        referrer,
        medium,
        campaign,
        campaign_date
      }, {
        path,
        expires
      });
    }
  };

  const removeTracking = () => removeCookie('CP_TRACKER');

  return [setTracking, removeTracking, trackingData];
};
const useCustomizedNltOffer = offerData => {
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
  const customizedOffer = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(state => state.nlt.customizedOffer);
  const variations = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(() => (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getAllOfferVariations */ .P9)(offerData), [offerData]);
  const defaultOffer = {
    code: offerData.code,
    contractLength: offerData.contractLength,
    annualMileage: offerData.annualMileage,
    deposit: offerData.deposit,
    monthlyRate: offerData.monthlyRate,
    variationId: 0
  };
  /* Ignoriamo la personalizzazione di un'altra offerta rimasta in store */

  const offer = customizedOffer && customizedOffer.code === offerData.code ? _objectSpread(_objectSpread({}, defaultOffer), customizedOffer) : defaultOffer;

  const getMonthlyRate = (contractLength, annualMileage, deposit) => (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getVariationPriceFromCombination */ .VI)(variations, contractLength, annualMileage, deposit);

  const selectVariationItem = (param, value) => {
    const selected = _objectSpread({}, offer);

    switch (param) {
      case 'duration':
        selected.contractLength = value;
        break;

      case 'distance':
        selected.annualMileage = value;
        break;

      case 'deposit':
        selected.deposit = value;
        break;

      default:
        return;
    }

    const {
      contractLength,
      annualMileage,
      deposit
    } = selected;
    dispatch((0,src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_7__/* .setCustomizedOffer */ .qN)(_objectSpread(_objectSpread({}, selected), {}, {
      monthlyRate: getMonthlyRate(contractLength, annualMileage, deposit),
      variationId: (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getVariationIdFromCombination */ .$7)(variations, contractLength, annualMileage, deposit)
    })));
  };

  return {
    offer,
    variations,
    getMonthlyRate,
    selectVariationItem
  };
};
const useSelectableDeposits = offerData => {
  const {
    offer,
    getMonthlyRate,
    selectVariationItem,
    variations
  } = useCustomizedNltOffer(offerData);
  const {
    deposits
  } = (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getOfferVariationsGrouped */ .Mi)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_6__/* .searchVariations */ .$e)(variations, offer.contractLength, offer.annualMileage, offer.deposit));

  const monthlyRateFromDeposit = deposit => {
    const monthlyRate = getMonthlyRate(offer.contractLength, offer.annualMileage, deposit);
    return monthlyRate === null || typeof monthlyRate === 'undefined' ? null : monthlyRate;
  };

  const selectableDeposits = deposits.filter(deposit => deposit === offer.deposit || monthlyRateFromDeposit(deposit) !== null).sort((depositA, depositB) => depositA - depositB);
  return {
    offer,
    selectableDeposits,
    hasDepositChoice: selectableDeposits.length > 1,
    monthlyRateFromDeposit,
    selectVariationItem
  };
};

/***/ }),

/***/ 88142:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noleggio-a-lungo-termine",
      function () {
        return __webpack_require__(89346);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3382,5675,9135,1113,3543,2702,9774,2888,179], function() { return __webpack_exec__(88142); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);